import { render, staticRenderFns } from "./go-top.vue?vue&type=template&id=08a6b501&scoped=true"
import script from "./go-top.vue?vue&type=script&lang=js"
export * from "./go-top.vue?vue&type=script&lang=js"
import style0 from "./go-top.vue?vue&type=style&index=0&id=08a6b501&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a6b501",
  null
  
)

export default component.exports